import { CreateTrainingExampleDialog } from './CreateTrainingExampleDialog';
import { useI18n } from '../../i18n/useI18n';

type ChatbotConversationTrainingDialogProps = {
  question: string;
  answer: string;
  isSubmitting: boolean;
  onCreate: (input: {
    question: string;
    answer: string;
    sortOrder: number | null;
  }) => void;
  onClose: () => void;
};

export function ChatbotConversationTrainingDialog({
  question,
  answer,
  isSubmitting,
  onCreate,
  onClose,
}: ChatbotConversationTrainingDialogProps) {
  const { translate } = useI18n();

  return (
    <CreateTrainingExampleDialog
      title={translate(
        'chatbots.conversations.detail.createTrainingDialogTitle',
      )}
      questionLabel={translate('chatbots.training.questionLabel')}
      questionPlaceholder={translate('chatbots.training.questionPlaceholder')}
      answerLabel={translate('chatbots.training.answerLabel')}
      answerPlaceholder={translate('chatbots.training.answerPlaceholder')}
      sortOrderLabel={translate('chatbots.training.sortOrderLabel')}
      sortOrderPlaceholder={translate('chatbots.training.sortOrderPlaceholder')}
      sortOrderHint={translate('chatbots.training.sortOrderHint')}
      createLabel={translate('chatbots.training.createSubmit')}
      cancelLabel={translate('chatbots.training.cancel')}
      closeLabel={translate('chatbots.training.close')}
      initialQuestion={question}
      initialAnswer={answer}
      initialSortOrder={1}
      isSubmitting={isSubmitting}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
}
